import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { Auth } from "aws-amplify";

import Alert from "components/shared/common/alert";
import onSignIn from "components/shared/utils/onSignIn";
import { loginRequest } from "components/msal/msalConfig";
import { addAudience } from "components/shared/mailchimp";
import { setIsLoading } from "redux/loader/action";
import { set_sign_in_details } from "redux/signin/action";
import SocialSignIn from "./components/SocialSignIn";
import InputContainer from "./components/InputContainer";

const SignUp = ({ history }) => {
  const dispatch = useDispatch();
  const { instance } = useMsal();
  const {
    gameReducer: { gameName } = {},
    signinReducer: { sign_in_details: { sign_up, sign_up_with_email } = {} }
  } = useSelector((state) => state);

  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    password: ""
  });

  const handleIsLoading = (value) => dispatch(setIsLoading(value));

  const hendleForgetPassword = () => history.push("/password_reset");

  const handleSignInChange = () =>
    dispatch(set_sign_in_details({ sign_up: !sign_up, sign_up_with_email }));

  const handleSignInWithEmail = () =>
    dispatch(set_sign_in_details({ sign_up, sign_up_with_email: true }));

  const handleSignIn = (service) => {
    switch (service) {
      case "Microsoft":
        instance.loginRedirect(loginRequest).catch((e) => {
          console.log(e, "eeeeeeeee");
        });
        break;
      case "Email":
        handleSignInWithEmail();
        break;
      default:
        Auth.federatedSignIn({
          provider: service
        });
        break;
    }
  };

  const handleInputChange = (value, name) =>
    setUserDetails((prev) => ({ ...prev, [name]: value }));

  const setRedirectUrl = async (data) => {
    let payload = data.signInUserSession.idToken.payload;
    await onSignIn(payload);
    dispatch(
      set_sign_in_details({ sign_up: false, sign_up_with_email: false })
    );
    if (gameName) {
      history.push("/lobby");
    } else {
      history.push("/");
    }
  };

  const validateInputs = (name, email, password) =>
    name.trim() !== "" && email.trim() !== "" && password.trim() !== "";

  const onEmailSignUp = () => {
    const { name, email, password } = userDetails;
    const isValid = validateInputs(name, email, password);
    if (!isValid) return Alert(400, "Incorrect name, email, or password");
    if (password.trim().length < 8)
      return Alert(400, "Password must be 8 characters");

    handleIsLoading(true);
    Auth.signUp({
      username: email,
      password,
      attributes: { email, name }
    })
      .then((data) => {
        Alert(200, "You have successfully registered");
        if (data) {
          addAudience({ email: data.user.username });
          Auth.signIn(email, password)
            .then((data) => {
              setRedirectUrl(data);
              localStorage.setItem("auth", "login");
            })
            .catch((error) => {
              handleIsLoading(false);
              Alert(400, error.message);
            });
        }
      })
      .catch((error) => {
        handleIsLoading(false);
        Alert(400, error.message);
      });
  };

  const onEmailSignIn = () => {
    if (userDetails.email !== "" && userDetails.password !== "") {
      handleIsLoading(true);
      Auth.signIn(userDetails.email, userDetails.password)
        .then((data) => {
          setRedirectUrl(data);
          localStorage.setItem("auth", "login");
        })
        .catch((error) => {
          handleIsLoading(false);
          Alert(400, error.message);
        });
    } else {
      Alert(400, "Incorrect email or password");
    }
  };

  return (
    <div className={`signup-main ${sign_up_with_email ? "email" : ""}`}>
      <h2 className="title">{sign_up ? "Sign Up" : "Login"}</h2>
      <p className={`desc ${sign_up ? "" : "signin"}`}>
        {sign_up
          ? "Get started building team culture today!"
          : "Welcome back, sign in to continue building team culture."}
      </p>
      {sign_up && (
        <p className="desc bold-text">Free for up to 10 teammates.</p>
      )}

      {sign_up_with_email ? (
        <InputContainer
          sign_up={sign_up}
          user={userDetails}
          onEmailSignIn={onEmailSignIn}
          onEmailSignUp={onEmailSignUp}
          onInputChange={handleInputChange}
          onForgetPassword={hendleForgetPassword}
        />
      ) : (
        <SocialSignIn onSignIn={handleSignIn} />
      )}

      <p className="bottom-text">
        {sign_up ? "Already have an account?" : "Need an account?"}{" "}
        <span className="bold-text" onClick={handleSignInChange}>
          {sign_up ? "Log In" : "Sign Up"}
        </span>
      </p>
    </div>
  );
};

export default SignUp;
